import {tooltip} from "../../assets/jss/material-dashboard-pro-react.jsx";
import {specialScrollbar} from "assets/jss/special-scrollbar.jsx";

const styles = {
  tooltip,
  wrapper: {
    overflow: "auto",
    ...specialScrollbar,
    margin: "40px -30px",
    ['@media (max-width:780px)']: {
      margin: "10px -30px",
    },
    textAlign: "center",
    "& > div": {
      padding: 20,
      display: "flex",
      flexDirection: "row",
      ['@media (max-width:780px)']: {
        display: "inline-flex",
        flexDirection: "column",
        minWidth: "0!important"
      },
    }
  },
  itemWrapper: {
    flexGrow: 1,
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    ['@media (max-width:780px)']: {
      flexDirection: "row",
    },
    position: "relative",
    "&:not(:first-child):before, &:not(:last-child):after": {
      content: '""',
      width: "50%",
      height: 0,
      top: 26,
      ['@media (max-width:780px)']: {
        width: 0,
        height: "50%",
        top: "initial",
        left: 19
      },
      border: "dashed 2px",
      borderColor: "#CCCCCC",
      position: "absolute"
    },
    "&:not(:first-child):before": {
      alignSelf: "flex-start"
    },
    "&:not(:last-child):after": {
      alignSelf: "flex-end"
    },
    "& > div": {
      textAlign: "center",
      marginTop: 10,
      ['@media (max-width:780px)']: {
        textAlign: "left",
        marginTop: 0,
        marginLeft: "10px"
      }
    }
  },
  itemWrapperActiveLeft: {
    "&:not(:first-child):before": {
      borderColor: "#32a84f",
      borderStyle: "solid"
    }
  },
  itemWrapperActiveRight: {
    "&:not(:last-child):after": {
      borderColor: "#32a84f",
      borderStyle: "solid"
    }
  },
  itemCircle: {
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    borderRadius: "50%",
    width: 55,
    height: 55,
    backgroundColor: "#eeeeee",
    zIndex: 1,
    border: "dashed 2px #32a84f",
    "& svg": {
      color: "#32a84f"
    },
    ['@media (max-width:780px)']: {
      margin: "8px 0",
      width: 40,
      height: 40,
      "& svg": {
        width: "15px!important"
      },
    },
  },
  itemCircleActive: {
    backgroundColor: "#32a84f",
    border: "solid 2px #32a84f",
    "& svg": {
      color: "white"
    }
  },
  itemText: {
    margin: 0
  },
  itemDate: {
    margin: 0,
    marginTop: 3,
    fontSize: 11,
    ['@media (max-width:780px)']: {
      marginTop: -3,
      fontSize: 9,
    },
    fontWeight: "bold"
  },
};

export {
  styles
}
